module.exports = __webpack_public_path__ + "img/logo_dgfm.1e49df89.svg";